import React from 'react';
import styled from 'styled-components';
import styledProps from 'styled-props';
import { colors } from '../../../tailwind';
import { Button as Base } from 'rebass';
import safeProps, { strippedProps } from '../../safeProps';

const backgrounds = {
  muted: 'transparent',
  primary: colors.secondary,
  secondary: colors.primaryDark,
  tertiary: 'transparent',
};

function getFontColor(props) {
  if (!props.muted) {
    if (props.tertiary) {
      return colors.grayDark;
    }
    return colors.white;
  }
  if (props.primary) {
    return colors.secondary;
  }
  return colors.primaryDark;
}

const Button = styled(props => {
  let nProps = props;
  const rest = strippedProps(nProps);
  return <Base {...rest} />;
})`
  height: ${props => (props.height ? props.height : '36px')};
  border-radius: ${props => buildBorderRadius(props)};
  background-color: ${styledProps(backgrounds)};
  border: ${props =>
    props.muted
      ? '1px solid ' +
        (props.primary ? backgrounds.primary : backgrounds.secondary)
      : 'none'};
  font-family: 'Helvetica';
  font-size: ${props => (props.small ? '10px' : '14px')};
  font-weight: ${props => (props.action ? 700 : 300)};
  font-style: normal;
  font-stretch: normal;
  line-height: 0.88;
  letter-spacing: ${props => (props.small ? '0.3px' : '0.4px')};
  padding-left: ${props =>
    props.px ? props.px : props.small ? '10px' : '24px'};
  padding-right: ${props =>
    props.px ? props.px : props.small ? '10px' : '24px'};
  color: ${p => getFontColor(p)};

  &:focus {
    box-shadow: none;
  }
`;

Button.defaultProps = {
  backgroundColor: 'secondary',
  color: 'other',
};

export default Button;

function buildBorderRadius(props) {
  if (props.roundedLeft) {
    return '19px 0px 0px 19px';
  } else if (props.roundedRight) {
    return '0px 19px 19px 0px';
  } else if (props.rounded) {
    return '19px 19px 19px 19px';
  } else {
    return '4px 4px 4px 4px';
  }
}



// WEBPACK FOOTER //
// ./src/components_new/common/FormComponents/Button.js